export class ForbiddenPortalRequested extends Error {
  constructor(message) {
    super(message);
  }
}
